// extracted by mini-css-extract-plugin
export default {"foundersSection":"Founders_foundersSection__OJw26","textContent":"Founders_textContent__bdqRZ","imageContent":"Founders_imageContent__Vr5b2"};